(function () {

  'use strict';

  eclipseApp.directive('countdown', ['util', '$interval',
    function () {
      return {
        restrict: 'A',
        scope: {
          date: '='
        },
        replace: true,
        template: '<span date=\'userInfo.expiry\'><strong>{{ timeLabel }}</strong></span>',
        controller: ['util', '$interval', '$scope', '$timeout', '$rootScope', function (util, $interval, $scope, $timeout, $rootScope) {

          $scope.cancelTicker = function(){
            $interval.cancel($scope.ticker);
          };

          $scope.$watch('date', function(nv, ov){
            if (!_.isUndefined(nv) && moment(nv).isValid()){

              var newExpiry = moment(new Date(nv));

              // check if ticker is already going; destroy it if it is
              $scope.cancelTicker();

              // check if the expiry time is valid
              if ((newExpiry.unix() - moment().unix()) > 0){
                $scope.timeLabel = util.parseAgentTimer((newExpiry.unix() - moment().unix()));

                // check if the expiry time is still valid
                if ( (newExpiry.unix() - moment().unix()) > 0 ) {
                  $scope.ticker = $interval(function () {

                    // one last time; in case the ticker has been initialized 
                    if ( (newExpiry.unix() - moment().unix()) > 0 ) {
                      $scope.timeLabel = util.parseAgentTimer((newExpiry.unix() - moment().unix()));
                    } else {
                      $scope.cancelTicker();
                      
                      // kick the agent out after session ends
                      $rootScope.ruiMethods.agent.signOut('retail.message.sessionExpiredLoginAgain');
                    }
                  }, 1000);
                }
              }
            } else {
              // cancel any ticker if the new time is not valid
              $scope.cancelTicker();
            }
          });

          // kill the ticker on $destroy of this directive
          $scope.$on('$destroy', function(){
            $scope.cancelTicker();
          });
        }]
      };
    }]);
})();